// extracted by mini-css-extract-plugin
module.exports = {"grayBg":"client_grayBg__1SXFq","whiteBg":"client_whiteBg__1vK-_","inputWrapBorder":"client_inputWrapBorder__q32DL"};